/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_New_FilterInputs */

const en_common_new_filter = /** @type {(inputs: Common_New_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New filter`)
};

/**
* | output |
* | --- |
* | "New filter" |
*
* @param {Common_New_FilterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_new_filter = /** @type {((inputs?: Common_New_FilterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_New_FilterInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_new_filter(inputs)
});